var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8607 8.15479C14.8607 13.5336 9.35149 16.8474 8.2066 17.4786C8.14318 17.5136 8.07193 17.5319 7.99949 17.5319C7.92706 17.5319 7.85581 17.5136 7.79238 17.4786C6.64664 16.8474 1.13916 13.5336 1.13916 8.15479C1.13916 3.86682 3.71195 0.865234 7.99992 0.865234C12.2879 0.865234 14.8607 3.86682 14.8607 8.15479Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56982 7.72726C4.56982 8.63705 4.93124 9.50958 5.57456 10.1529C6.21788 10.7962 7.09041 11.1576 8.0002 11.1576C8.91 11.1576 9.78253 10.7962 10.4258 10.1529C11.0692 9.50958 11.4306 8.63705 11.4306 7.72726C11.4306 6.81746 11.0692 5.94493 10.4258 5.30161C9.78253 4.65829 8.91 4.29688 8.0002 4.29688C7.09041 4.29688 6.21788 4.65829 5.57456 5.30161C4.93124 5.94493 4.56982 6.81746 4.56982 7.72726V7.72726Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.46ff81e39932658aeb26c8c3b58809a1.svg";
export { ForwardRef as ReactComponent };